import DataTableInit from './datatable.js';
import Modal from './modal.js';

$(document).ready(function() {
    if($('.today-visits-data-table').length) {

        var selected;

        var dataTable = $('.today-visits-data-table').DataTable({
            dom: 'lfrtipB',
            "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
            buttons: [{
                extend: 'csv',
                text: 'Export to CSV',
                exportOptions: {
                    modifier: {
                      page: 'all'
                    }
                }
                
            }],
            processing: true,
            serverSide: true,
            language : {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Visits today"
            },
            ajax: {
                url: window.site.todaysVisitsTableData,
                data: function(d) {
                    d.company = selected;
                }
            },
            columns: [
                { data: 'action', name: 'action', orderable: false, searchable: false, className: 'select-checkbox checkbox-td', targets: 0 },
                { data: 'id', name: 'visits.id', visible: false },
                { data: 'guests', name: 'visit_guest.first_name' }, // Need to hook onto something that actually exists but gets overwritten using filterColumn in visitRepo (known bug in current laravel datatables implementation)
                { data: 'company_name', name: 'company.company_name'},
                { data: 'company_employee', name: 'visits.company_employee'},
                { data: 'visitor_pass_number', name: 'visits.visitor_pass_number' },
                { data: 'vehicle_reg', name: 'visits.vehicle_reg' },
                { data: 'visit_date', name: 'visits.visit_date' },
                { data: 'leave_date_time', name: 'visits.leave_date_time' },
                { data: 'origin_company', name: 'visit_guest.company', visible:false },
                { data: 'courier_name', name: 'couriers.name', visible : false },
            ],
            "fnDrawCallback":function(){
                DataTableInit.handlePaginationState();
                DataTableInit.addDropdownArrows();
                DataTableInit.makeRowsClickable();
                DataTableInit.addDropdownArrowsSelectbox();
            },
            "fnInitComplete":function() {
                DataTableInit.addSearchCross();
                DataTableInit.makeRowsClickable();
            },
            'createdRow': function( row, data, dataIndex ) {
                $(row).attr('data-href', window.site.url + '/visit/' + data.id);
                $(row).attr('data-visit-id', data.id);
            },
            select: {
                style:    'multi',
                selector: 'td:first-child'
            }
        });

        DataTableInit.construct(dataTable, true);

        dataTable.order( [ 7, 'desc'] ).draw();

        // Filter
        $('.filter-btn').click(function(e) {
            e.preventDefault();

            selected = [];

            $('.site-modal input:checked').each(function() {
                selected.push($(this).attr('value'));
            });

            dataTable.draw();
            Modal.closeModal();
            if(isFilterEmpty()) {
                $('.download-btn').show();
            } else {
                $('.download-btn').hide();
            }
        });


        $('.clear-filter-btn').click(function(e){
            e.preventDefault();

            $('input:checkbox').prop('checked', false);
            dataTable.draw();
            Modal.closeModal();
            $('.download-btn').show();
        });

        function isFilterEmpty() {
            var isEmpty = false;
            var checkboxesTicked = [];

            $('.site-modal input:checked').each(function() {
                checkboxesTicked.push($(this).attr('value'));
            });

            // If dates and checkboxes all empty then true
            if(checkboxesTicked.length == 0) {
                isEmpty = true;
            }

            return isEmpty;
        }


    }
});

$('[data-trigger-csv]').click(function(e) {
    e.preventDefault();
   $('.dt-button.buttons-csv.buttons-html5').trigger('click');
});


// WEBPACK FOOTER //
// ./today-visits-datatable.js